import { render, staticRenderFns } from "./HeroComponent.vue?vue&type=template&id=2d318d54"
import script from "./HeroComponent.vue?vue&type=script&lang=ts"
export * from "./HeroComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports